import React from 'react';
import {startOfDay, format, parse} from "date-fns";
import DatePicker from "react-datepicker";
import {DATE_FORMATS} from "../../../constants/DateFormats";

const DateInput = (props) => {
    const {
        onChange = () => {},
        disabled = false,
        value = "",
        error = null,
        clearable = true,
        todayButton = null,
        className = "",
        showTimeSelect = false,
        showTimeSelectOnly = false,
        timeIntervals = 30,
        dateFormat = DATE_FORMATS.DATE,
    } = props;

    const parseDate = () => {
        if (!value || value === "") {
            return "";
        }

        if (showTimeSelectOnly) {
            return parse(value, DATE_FORMATS.HOUR_MINUTE, new Date());
        }

        if (showTimeSelect) {
            return parse(value, DATE_FORMATS.DB, new Date());
        }

        return parse(value, DATE_FORMATS.DB_DATE, startOfDay(new Date()));
    }

    const handleUpdate = (newValue) => {
        if (!newValue || newValue === "") {
            onChange(null);
        } else if (showTimeSelectOnly) {
            onChange(format(newValue, DATE_FORMATS.HOUR_MINUTE));
        } else if (showTimeSelect) {
            onChange(format(newValue, DATE_FORMATS.DB));
        } else {
            onChange(format(newValue, DATE_FORMATS.DB_DATE));
        }
    }

    return (
        <div className={"datepicker-container"}>
            <DatePicker
                selected={parseDate()}
                dateFormat={dateFormat}
                onChange={(newValue) => handleUpdate(newValue)}
                showMonthDropdown
                showYearDropdown
                dropdownMode={"select"}
                current
                isClearable={clearable && !(!value || value === "")}
                closeOnScroll={true}
                showPopperArrow={false}
                className={className + !error ? " form-control shadow-none" : " form-control shadow-none is-invalid"}
                disabled={disabled}
                disabledKeyboardNavigation
                minDate={parse('2020-01-01 00:00:00', DATE_FORMATS.DB, new Date())}
                maxDate={parse('2050-01-01 00:00:00', DATE_FORMATS.DB, new Date())}
                todayButton={todayButton}
                showTimeSelect={showTimeSelect}
                showTimeSelectOnly={showTimeSelectOnly}
                timeIntervals={timeIntervals}
                timeFormat={DATE_FORMATS.HOUR_MINUTE}
            />
        </div>
    );
}

export default DateInput;
